/** Salutation options for platform sign-up; values are persisted and sent to Stripe metadata as `title`. */
export const SIGN_UP_TITLE_VALUES = ["Mr.", "Mrs.", "Miss", "Ms.", "Mx.", "Dr.", "Prof.", "Prefer not to say"] as const;

export type SignUpTitle = (typeof SIGN_UP_TITLE_VALUES)[number];
